import { Component, h } from '@stencil/core';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-custom-t-shirts',
  styleUrl: '../ci-apparel/ci-apparel.scss',
  shadow: true,
})
export class ciCustomTShirts {
  render() {
    const click_section = "custom tshirts";
    return (
      <div class="ciProducts ciProducts--noPadding">
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/short-sleeve-t-shirts/16`}
                data-section={click_section}
                data-link="Short Sleeve T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Short Sleeve T-shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/long-sleeve-t-shirts/17`}
                data-section={click_section}
                data-link="Long Sleeve T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Long Sleeve T-shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/tank-tops-sleeveless/18`}
                data-section={click_section}
                data-link="Tank Tops & Sleeveless"
                onClick={trackAnalyticsEvent}
              >
                Tank Tops & Sleeveless
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/performance-blend-shirts/505`}
                data-section={click_section}
                data-link="Performance Shirts"
                onClick={trackAnalyticsEvent}
              >
                Performance Shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/soft-tri-blend-t-shirts/399`}
                data-section={click_section}
                data-link="Soft Tri-Blend T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Soft Tri-Blend T-shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/sustainable/sustainable-t-shirts/773`}
                data-section={click_section}
                data-link="Sustainable T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Sustainable T-shirts
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/womens-t-shirts/104`}
                data-section={click_section}
                data-link="Women’s T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Women’s T-shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/kids-t-shirts/197`}
                data-section={click_section}
                data-link="Kids T-shirts"
                onClick={trackAnalyticsEvent}
              >
                Kids T-shirts
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/no-minimum-t-shirts/198?min_qty%5B%5D=1`}
                data-section={click_section}
                data-link="No Minimum T-shirts"
                onClick={trackAnalyticsEvent}
              >
                No Minimum T-shirts
              </a>
            </li>
            <li>
              <a
                href={`${process.env.CI_HOSTNAME}/products/t-shirts/4`}
                data-section={click_section}
                data-link="View All Custom T-shirts"
                onClick={trackAnalyticsEvent}
              >
                View All Custom T-shirts
              </a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-image ciProducts-image--tshirts">
        </div>
      </div>
    );
  }
}
